var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPontem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9652 58.7172V44.5254C50.7119 45.466 54.4129 46.85 58.1321 48.6537C55.345 52.8911 51.4932 56.3656 46.9652 58.7172ZM26.29 61.2012V28.0508C26.29 24.2152 29.4386 21.0412 33.1944 21.0412C36.9548 21.0412 40.0065 24.1462 40.0065 27.9728C40.0065 28.0002 39.9928 28.028 39.9928 28.0508H40.0065V39.5851C36.8081 39.2153 33.5961 39.0965 30.3794 39.2655L27.7384 43.1007C31.8552 42.7537 35.8628 42.7815 39.8196 43.2336C39.8608 43.2336 39.8836 43.2331 39.9247 43.2468C39.9521 43.2468 39.9791 43.2473 40.0156 43.261C40.7056 43.3431 43.214 43.6582 45.5123 44.229L40.0156 46.1007V61.3022C37.8636 61.7953 35.6339 62.0738 33.3493 62.0738C30.9003 62.051 28.5472 61.7446 26.29 61.2012ZM8.40657 48.4706C11.9248 46.7308 15.5755 45.3888 19.3359 44.4619V58.535C14.8856 56.156 11.1298 52.6761 8.40657 48.4706ZM33.331 2.65298C49.7021 2.65298 63.0302 15.9818 63.0302 32.3518C63.0302 37.0504 61.9295 41.5116 59.9785 45.466C55.7018 43.3975 51.3607 41.8546 46.979 40.8089V16.0366C46.979 15.1736 46.3027 14.4841 45.4529 14.4841H40.0111H26.2946H20.8528C20.0167 14.4841 19.3267 15.1736 19.3267 16.0366V40.9276C15.0775 41.9779 10.8556 43.4888 6.69773 45.4797C4.73301 41.5116 3.63185 37.0641 3.63185 32.3518C3.62728 15.9864 16.9599 2.65298 33.331 2.65298ZM33.331 0C15.4887 0 0.972656 14.5115 0.972656 32.3518C0.972656 45.1783 8.47511 56.288 19.3222 61.5163V61.5437H19.377C23.5988 63.5757 28.3416 64.7172 33.331 64.7172C51.1779 64.7172 65.6899 50.2062 65.6899 32.3659C65.6853 14.512 51.1734 0 33.331 0Z",
    fill: "url(#paint0_linear_462_278)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_278",
    x1: 1.99659,
    y1: 32.381,
    x2: 66.7125,
    y2: 32.2932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D29C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0858,
    stopColor: "#8D29C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#942BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#A92FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7413,
    stopColor: "#CA3793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03F77"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontem);
export default __webpack_public_path__ + "static/media/pontem.f88b508837487e3ce1e362476f283343.svg";
export { ForwardRef as ReactComponent };